// src/components/PresensiSearchFilterBar.js
import React from "react";
import PropTypes from "prop-types";

export default function PresensiSearchFilterBar({
  q, onQChange,
  roleFilter, onRoleChange,
  genderFilter, onGenderChange,
  sortBy, onSortChange,
  showDonation, onToggleShowDonation
}) {
  return (
    <div className="presensi-controls" style={{
      display: "flex",
      gap: "0.6rem",
      alignItems: "center",
      marginBottom: "0.75rem",
      fontSize: "0.875rem",
      flexWrap: "wrap"
    }}>
      <input
        type="search"
        placeholder="Search by name, code, or address..."
        value={q}
        onChange={(e) => onQChange(e.target.value)}
        style={{
          flex: "1 1 320px",
          minWidth: "120px",
          padding: "0.5rem 0.75rem",
          borderRadius: "0.5rem",
          border: "1px solid #e6e6e6",
          fontSize: "0.9375rem"
        }}
      />

      <select value={roleFilter} onChange={(e) => onRoleChange(e.target.value)}
        style={{ padding: "0.45rem 0.6rem", borderRadius: "0.45rem", fontSize: "0.875rem" }}>
        <option value="all">All (Peserta/Petugas)</option>
        <option value="peserta">班員 Peserta</option>
        <option value="petugas">辦事 Petugas</option>
      </select>

      <select value={genderFilter} onChange={(e) => onGenderChange(e.target.value)}
        style={{ padding: "0.45rem 0.6rem", borderRadius: "0.45rem", fontSize: "0.875rem" }}>
        <option value="all">All Gender</option>
        <option value="male">乾 Pria</option>
        <option value="female">坤 Wanita</option>
      </select>

      <select value={sortBy} onChange={(e) => onSortChange(e.target.value)}
        style={{ padding: "0.45rem 0.6rem", borderRadius: "0.45rem", fontSize: "0.875rem" }}>
        <option value="name">Sort: Nama</option>
        <option value="seqNo">Sort: Nomor</option>
      </select>
    </div>
  );
}

PresensiSearchFilterBar.propTypes = {
  q: PropTypes.string,
  onQChange: PropTypes.func,
  roleFilter: PropTypes.string,
  onRoleChange: PropTypes.func,
  genderFilter: PropTypes.string,
  onGenderChange: PropTypes.func,
  sortBy: PropTypes.string,
  onSortChange: PropTypes.func,
  showDonation: PropTypes.bool,
  onToggleShowDonation: PropTypes.func,
};
